import React from 'react'
import Surveys from '../Surveys'
import { useTenant } from '../context/TenantContext'

export function TenantSurveysTab() {
    const { tenantId } = useTenant()
    return <Surveys tenant_id={tenantId} />
}
